import React from 'react';
import { Check, Lock } from 'lucide-react';
import { sendPixelEvent } from '../../App';
const CHECKOUT_URL = 'https://pay.hotmart.com/O104832352I';
const PIXEL_PARAMS = {
  content_name: 'Celular bajo control, hogar en paz',
  content_type: 'product',
  value: 6.36,
  currency: 'USD'
};
const handleCheckoutClick = (e: React.MouseEvent) => {
  e.preventDefault();
  // Fire AddToCart immediately (SDK + image fallback)
  sendPixelEvent('AddToCart', PIXEL_PARAMS);
  // Fire InitiateCheckout after 300ms to ensure AddToCart is registered separately
  setTimeout(() => {
    sendPixelEvent('InitiateCheckout', PIXEL_PARAMS);
  }, 300);
  // Navigate to checkout after 500ms to ensure both events are sent
  setTimeout(() => {
    window.open(CHECKOUT_URL, '_blank', 'noopener,noreferrer');
  }, 500);
};
export function OfferStackSection() {
  return <section id="offer-section" className="bg-alternate py-10 md:py-24 px-4 scroll-mt-10" data-id="element-116">
      <div className="max-w-4xl mx-auto" data-id="element-117">
        <div className="bg-primary rounded-3xl shadow-card border-2 border-accent overflow-hidden" data-id="element-118">
          <div className="bg-trust text-white text-center py-4 px-6" data-id="element-119">
            <h2 className="text-xl md:text-2xl font-bold font-heading" data-id="element-120">
              Resumen de tu pedido hoy
            </h2>
          </div>

          <div className="p-5 md:p-12" data-id="element-121">
            <div className="flex flex-col md:flex-row gap-6 md:gap-8 items-center mb-8 md:mb-10" data-id="element-122">
              <div className="w-full md:w-1/3 flex justify-center" data-id="element-123">
                <img src="https://cdn.magicpatterns.com/uploads/h78tCJ2b46bbpyXU1hyyLc/portada.png" alt="Guía Celular bajo control" className="w-36 md:w-full max-w-[200px] drop-shadow-md" data-id="element-124" />
              </div>

              <div className="w-full md:w-2/3" data-id="element-125">
                <ul className="space-y-3 md:space-y-4" data-id="element-126">
                  <li className="flex items-center justify-between border-b border-border pb-3" data-id="element-127">
                    <div className="flex items-center gap-2 md:gap-3" data-id="element-128">
                      <Check className="w-4 h-4 md:w-5 md:h-5 text-success flex-shrink-0" data-id="element-129" />
                      <span className="text-sm md:text-lg text-text-primary font-medium" data-id="element-130">
                        Guía "Celular bajo control, hogar en paz"
                      </span>
                    </div>
                    <span className="text-text-secondary line-through text-xs md:text-sm flex-shrink-0 ml-2" data-id="element-131">
                      $29.00
                    </span>
                  </li>
                  <li className="flex items-center justify-between border-b border-border pb-3" data-id="element-132">
                    <div className="flex items-center gap-2 md:gap-3" data-id="element-133">
                      <Check className="w-4 h-4 md:w-5 md:h-5 text-success flex-shrink-0" data-id="element-134" />
                      <span className="text-sm md:text-lg text-text-primary font-medium" data-id="element-135">
                        Bono: Plantilla de Acuerdo Familiar
                      </span>
                    </div>
                    <span className="text-text-secondary line-through text-xs md:text-sm flex-shrink-0 ml-2" data-id="element-136">
                      $15.00
                    </span>
                  </li>
                  <li className="flex items-center justify-between border-b border-border pb-3" data-id="element-137">
                    <div className="flex items-center gap-2 md:gap-3" data-id="element-138">
                      <Check className="w-4 h-4 md:w-5 md:h-5 text-success flex-shrink-0" data-id="element-139" />
                      <span className="text-sm md:text-lg text-text-primary font-medium" data-id="element-140">
                        Bono: Checklist de Seguridad
                      </span>
                    </div>
                    <span className="text-text-secondary line-through text-xs md:text-sm flex-shrink-0 ml-2" data-id="element-141">
                      $12.00
                    </span>
                  </li>
                </ul>

                <div className="mt-4 md:mt-6 flex items-center justify-between bg-white p-3 md:p-4 rounded-xl border border-border" data-id="element-142">
                  <span className="text-base md:text-lg font-bold text-text-primary" data-id="element-143">
                    Valor Total:
                  </span>
                  <span className="text-base md:text-lg font-bold text-coral line-through" data-id="element-144">
                    $56.00
                  </span>
                </div>
              </div>
            </div>

            <div className="text-center bg-white p-6 md:p-8 rounded-2xl border-2 border-coral/20 shadow-sm relative" data-id="element-145">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-coral text-white text-xs font-bold uppercase tracking-wider py-1 px-4 rounded-full whitespace-nowrap" data-id="element-146">
                Oferta Especial
              </div>
              <p className="text-text-secondary font-medium mb-2 mt-2" data-id="element-147">
                Llévate todo hoy por un único pago de:
              </p>
              <div className="text-5xl md:text-7xl font-bold text-text-primary mb-5 md:mb-6 font-heading" data-id="element-148">
                $6.36
              </div>

              <div className="flex justify-center" data-id="element-149">
                <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={handleCheckoutClick} className="cta-animate inline-flex items-center justify-center w-full max-w-[340px] bg-coral hover:bg-coral-hover text-white font-bold text-lg md:text-xl py-4 md:py-5 px-8 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 relative overflow-hidden" data-id="element-150">
                  <span className="relative z-10" data-id="element-151">
                    ¡Sí, quiero la guía ahora!
                  </span>
                </a>
              </div>

              <p className="text-sm text-text-secondary mt-4 flex items-center justify-center gap-2" data-id="element-152">
                <Lock className="w-4 h-4 text-success" data-id="element-153" />
                <span data-id="element-154">Pago 100% seguro y encriptado</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}